import { render } from "./SelectionWizard.vue?vue&type=template&id=320e317b&scoped=true"
import script from "./SelectionWizard.vue?vue&type=script&lang=js"
export * from "./SelectionWizard.vue?vue&type=script&lang=js"

import "./SelectionWizard.vue?vue&type=style&index=0&id=320e317b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320e317b"]])

export default __exports__